import { render, staticRenderFns } from "./LmPeopleSearcher.vue?vue&type=template&id=e78879b2"
import script from "./LmPeopleSearcher.vue?vue&type=script&lang=js"
export * from "./LmPeopleSearcher.vue?vue&type=script&lang=js"
import style0 from "./LmPeopleSearcher.vue?vue&type=style&index=0&id=e78879b2&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports